import { Outlet, useNavigate } from "react-router-dom";
import { useStore } from "./store";
import { logout } from "./store";
import NavigationPanel from "./NavigationPanel";
import { Grid } from "@mui/material";
import axios from "axios";
import api from "./api";
import { API_BASE_URL, VA_LOGOUT_URL} from "./settings";

export default function BaseLayout() {
  const { state, dispatch } = useStore();
  const navigate = useNavigate();

  const handleLogout = async () => {
    try {
      await api.get(`${API_BASE_URL}/api/logout/`, { withCredentials: true });
    } catch (e) {
      // Ignore errors, proceed with logout
    }
    dispatch(logout());
    window.location.href = VA_LOGOUT_URL;
    window.location.replace(VA_LOGOUT_URL);
    console.log("Redirecting to logout URL:", VA_LOGOUT_URL);
    navigate("/login");
  };

  return (
    <div className="base-layout">
      <main style={{ display: 'flex', height: '100vh', width: '100vw' }}>
        <NavigationPanel email={state.user.email} name={state.user.email} logout={handleLogout} authenticated={true}></NavigationPanel>
        <Grid container style={{ flexGrow: 1, }}>
            <Outlet />
        </Grid>
      </main>
    </div>
  );
}
